Components.SetupGuideStreamlinedIndex = {
    bindings: {
        value: '<',
        isLoading: '<',
        isNext: '<',
        isComplete: '<',
        isFinal: '<',
    },
    name: 'hbSetupGuideStreamlinedIndex',
    templateUrl: 'angular/app/modules/core/features/home/home_card_setup_guide_streamlined/setup_guide_streamlined_index.html',
    // @ngInject
    controller: function SetupGuideStreamlinedIndexController(
        $scope,
        $element,
        $attrs
    ) {
        this.$onInit = function () {
        }

    }
};